import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-plus",
  "use": "icon-plus-usage",
  "viewBox": "0 0 47 47",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 47 47\" id=\"icon-plus\"><path d=\"M43.731 20.811H26.183V3.263a2.925 2.925 0 1 0-5.849 0v17.548H2.786a2.925 2.925 0 1 0 0 5.85h17.548v17.547a2.925 2.925 0 1 0 5.85 0V26.66H43.73a2.925 2.925 0 0 0 0-5.849z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol